import { FC, ReactNode } from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';

export const SectionHeader: FC<{
  title: string;
  subtitle?: string;
  action?: ReactNode;
}> = ({ title, subtitle, action }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <Stack>
        <Typography
          variant='subtitle1'
          sx={{
            fontWeight: theme.typography.fontWeightMedium,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant='caption'
            sx={{
              color: 'text.secondary',
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Stack>
      {action}
    </Box>
  );
};
